import { render } from "./MetricGccWarningsDetailPage.vue?vue&type=template&id=20033ae4&scoped=true"
import script from "./MetricGccWarningsDetailPage.vue?vue&type=script&lang=js"
export * from "./MetricGccWarningsDetailPage.vue?vue&type=script&lang=js"

import "./MetricGccWarningsDetailPage.vue?vue&type=style&index=0&id=20033ae4&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20033ae4"]])

export default __exports__